/** Conversions */
export const DEFAULT_CONVERSIONS_PERIOD_HOUR = 24;
export const MIN_CONVERSIONS_PERIOD_HOUR = 1;
export const MAX_CONVERSIONS_PERIOD_HOUR = 168;

export const CONVERSION_ATTRIBUTION_ERROR_MESSAGE = `Please use a time period greater than ${MIN_CONVERSIONS_PERIOD_HOUR} hour and less than ${
  MAX_CONVERSIONS_PERIOD_HOUR + 1
} hours.`;

export const ATTRIBUTION_VALIDATION_KEY = 'conversions';
export const ATTRIBUTION_PERIOD_HOURS = 'periodHours';
export const ATTRIBUTION_MODE = 'mode';
export const ATTRIBUTION_MODE_KEY = `${ATTRIBUTION_VALIDATION_KEY}.${ATTRIBUTION_MODE}`;
export const ATTRIBUTION_PERIOD_HOURS_KEY = `${ATTRIBUTION_VALIDATION_KEY}.${ATTRIBUTION_PERIOD_HOURS}`;
